module.exports = __webpack_public_path__ + "img/gb93-87_6.prt.b2d901ae.jpg";